export function after(func, callback) {
  return (...args) => {
    func(...args);
    callback(...args);
  };
}
